/*******************************************************************************
 * Initial state
 */
const initialState = {
    loading: false
};

/*******************************************************************************
 * Non-async action types
 */
export const LOADING_START = 'loading/start';
export const LOADING_END   = 'loading/end';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function startLoading( ) {
    return {
        type: LOADING_START
    };
}
export function endLoading( ) {
    return {
        type: LOADING_END
    };
}
